/**
 * 事件机制
 *     on:绑定事件
 *        单个事件绑定示例
 *          $_EventLib.on('myEvent',callback)
 *        多个事件绑定示例
 *          $_EventLib.on([{
 *              eventType:'myEvent',
 *              callback:cb
 *          },{
 *              eventType:'myEvent2',
 *              callback:cb2
 *          }])
 *     dispatch:触发事件
 *        示例
 *          $_EventLib.dispatch('myEvent',{msg:'hello'})
 *     remove:删除事件
 *        单个事件删除示例
 *          $_EventLib.remove('myEvent')
 *
 */
var docTarget = document.getElementById('app') || document;
if (!docTarget.eventListeners) {
    docTarget.eventListeners = {};
}
/**
 * [ 绑定监听 ]
 * @param  {string | array} eventType [ 事件类型 ]
 * @param  {function | null | undefined} callback [ 事件回调 ]
 */
docTarget.onEvent = function (eventType, callback) {
    if (typeof eventType === 'string') {
        if (!this.eventListeners[eventType]) {
            this.eventListeners[eventType] = [];
        }
        this.eventListeners[eventType].push(callback);
    }
    else if (Object.prototype.toString.call(eventType) === '[object Array]') {
        for (var i = 0; i < eventType.length; i++) {
            if (Object.prototype.toString.call(eventType[i]) === '[object Object]') {
                if (!eventType[i].eventType) {
                    console.log('onEvent:入参{array(<object>)=>缺少eventType参数}');
                }
                else if (!eventType[i].callback) {
                    console.log('onEvent:入参{array(<object>)=>缺少callback回调函数}');
                }
                else {
                    if (!this.eventListeners[eventType[i].eventType]) {
                        this.eventListeners[eventType[i].eventType] = [];
                    }
                    this.eventListeners[eventType[i].eventType].push(eventType[i].callback);
                }
            }
            else {
                console.error('onEvent:入参{array(<object>)=>数据格式错误}');
                break;
            }
        }
    }
};
/**
 * [ 监听触发 ]
 * @param  {string | array} eventType [ 事件类型 ]
 * @param  {any} eventData [ 传参 ]
 */
docTarget.dispatchEvent = function (eventType, eventData) {
    for (var i in this.eventListeners[eventType]) {
        this.eventListeners[eventType][i].call(docTarget, eventData);
    }
};
/**
 * [ 监听移除 ]
 * @param  {string | array} eventType [ 事件类型 ]
 */
docTarget.removeEvent = function (eventType, fn) {
    var eventArray = [];
    if (typeof eventType === 'string' && fn) {
        if (this.eventListeners[eventType]) {
            this.eventListeners[eventType].forEach(function (item) {
                if (item !== fn) {
                    eventArray.push(item);
                }
            });
        }
        this.eventListeners[eventType] = eventArray.length ? eventArray : null;
    }
    else {
        console.log('removeEvent:请输入正确的参数类型');
    }
};
export default {
    on: function (eventType, callback) {
        docTarget.onEvent(eventType, callback);
    },
    dispatch: function (eventType, eventData) {
        docTarget.dispatchEvent(eventType, eventData);
    },
    remove: function (eventType, fn) {
        docTarget.removeEvent(eventType, fn);
    },
};
